import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BaseCrudService } from './base-crud.service';
import { Observable } from 'rxjs';
import { HttpEvent } from '@angular/common/http';
import { ApiItemResponse } from '../models/api';

export interface PresignedDownload {
  url: string;
  expiresIn?: number;
}

@Injectable({
  providedIn: 'root',
})
export class FileStorageService extends BaseCrudService<any> {
  protected resource: string = 'file-storage';
  protected apiRoot: string = environment.baseUrl;
  baseUrl: string = `${this.apiRoot}`;

  uploadFile(formData: FormData): Observable<any> {
    return this.http.post<ApiItemResponse<any>>(
      `${this.apiRoot}/${this.resource}/upload`,
      formData,
    );
  }

  uploadFileWithProgress(formData: FormData): Observable<HttpEvent<ApiItemResponse<any>>> {
    return this.http.post<ApiItemResponse<any>>(
      `${this.apiRoot}/${this.resource}/upload`,
      formData,
      { observe: 'events', reportProgress: true },
    );
  }

  presignDownload(
    id: string,
  ): Observable<ApiItemResponse<PresignedDownload>> {
    return this.http.get<ApiItemResponse<PresignedDownload>>(
      `${this.apiRoot}/${this.resource}/presign/download`,
      { params: { id } },
    );
  }
}
